import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

// Winter = CIA NACIONAL DE CHOCOLATES. Sus categorías cuelgan de este proveedor.
const WINTER_BP_ID = 17;
const ZONALES = ['NORTE', 'SUR'];

export default WithApp(function ModalIndicador(props) {
  const indicador = props.model;
  const periodo = moment(indicador.valueSearch?.Periodo).format('YYYY-MM');
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);

  const [categorias, setCategorias] = useState([]);
  const [categoria, setCategoria] = useState(indicador.logi_category_id);

  async function listCategorias() {
    let response = await wsFindBy('logi/category', {
      base_business_partner_id: WINTER_BP_ID,
      state: 'A',
    });
    if (response.success) setCategorias(response.data);
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      const uniqueZones = response.data.filter((zone, index, arr) => {
        return arr.findIndex((item) => item.defCashier === zone.defCashier) === index;
      });

      const filteredZones = uniqueZones.map(({ defCashier, ...zone }) => zone);
      setZones(filteredZones);
    }
  }

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    listCategorias();
    setCategoria(indicador.logi_category_id);
    listZones();
  }, [indicador.open]);

  useEffect(() => {
    if (zones.length > 0 && indicador.zonal) {
      handleChange("zonal", String(indicador.zonal));
    }
  },[zones]);

  return (
    <>
      <Modal
        title={`Indicador de Winter`}
        model={indicador}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/winter-indicators'
        dataForce={{
          logi_category_id: categoria,
          zonal: dataChanging.zonal,
          // type: dataChanging.type,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!indicador ? indicador.type : ''}
            inputProps={{
              name: 'type',
            }}
          >
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
          </Select>
        </FormControl>
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonal" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('zonal', item?.code);}}
          value={zones.find((zone) => String(zone.code) === String(dataChanging.zonal)) || null }
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={categorias}
          getOptionLabel={(item) => `${item.code} - ${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Categoría" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { setCategoria(item?.id); }}
          value={categorias.find((c) => String(c.id) === String(categoria)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!indicador ? indicador.description : ''}
          required
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!indicador ? indicador.quota : ''}
        />
      </Modal>
    </>
  );
});
